import { ModalWrapper } from 'src/components'
import { ISetStockImage, ISetStockVideo } from 'src/types'
import { ImageCropper } from './image-cropper.component'

import { useStyles } from './styles'

interface IProps {
  open: boolean
  handleClose: () => void
  setImage: (image: any) => void
  imageToCrop: any
  initialAspectRatio?: string
}

export const ImageCropperModal = ({
  open,
  handleClose,
  setImage,
  imageToCrop,
  initialAspectRatio,
}: IProps) => {
  const classes = useStyles()

  return (
    <ModalWrapper onClose={handleClose} open={open} withoutX className={classes.modalWrapper}>
      <ImageCropper
        imageToCrop={imageToCrop}
        setImage={setImage}
        initialAspectRatio={initialAspectRatio}
        handleCloseModal={handleClose}
      />
    </ModalWrapper>
  )
}
